import React, { useState } from "react";
import { Card, Row, Col, Form } from "react-bootstrap";
import { Rider } from "../../../types/model";
import BudgetModeEligibleRiderCard from "./BudgetModeEligibleRiderCard";
import { GameModeAssignemts, Gender } from "../../../constants/constants";

interface EligibleRidersSectionProps {
	uniqueCountries: string[];
	eligibleRiders: Rider[];
	sport?: string;
	isAddDisabled: (gender: Gender, rider: Rider) => boolean;
	addRiderToTeam: (rider: Rider) => void;
	gameModeAssignment: GameModeAssignemts;
}

const EligibleRidersSection: React.FC<EligibleRidersSectionProps> = ({
	uniqueCountries,
	eligibleRiders,
	sport,
	isAddDisabled,
	addRiderToTeam,
	gameModeAssignment,
}) => {
	// local state
	const [sortKey, setSortKey] = useState("last_name");
	const [sortOrder, setSortOrder] = useState("asc");
	const [filterGender, setFilterGender] = useState("");
	const [filterCountry, setFilterCountry] = useState("");
	const [searchText, setSearchText] = useState("");

	// functions
	const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
		setSearchText(e.target.value);
	};

	const sortedAndFilteredRiders = eligibleRiders
		.filter(
			(rider) =>
				(filterGender ? rider.gender === filterGender : true) &&
				(filterCountry
					? (rider.country?.toLowerCase() ?? "") === filterCountry.toLowerCase()
					: true) &&
				(searchText
					? (rider.first_name?.toLowerCase() ?? "").includes(
							searchText.toLowerCase(),
					  ) ||
					  (rider.last_name?.toLowerCase() ?? "").includes(
							searchText.toLowerCase(),
					  )
					: true),
		)
		.sort((a, b) => {
			let compareA =
				sortKey === "rating"
					? (a.ratings ?? []).find((r: any) => r.sport.toString() === sport)
							?.rating || 0
					: a[sortKey as keyof Rider];
			let compareB =
				sortKey === "rating"
					? b.ratings?.find((r: any) => r.sport.toString() === sport)?.rating ??
					  (0 || 0)
					: b[sortKey as keyof Rider];

			if (sortOrder === "asc") {
				return (compareA ?? 0) > (compareB ?? 0) ? 1 : -1;
			} else {
				return (compareA ?? 0) < (compareB ?? 0) ? 1 : -1;
			}
		});

	return (
		<Card className="mb-3 bg-secondary text-light border-0">
			<Card.Header className="fs-3 fw-bold">Eligible Riders</Card.Header>
			<Card.Body>
				<Row className="mb-2">
					<Col md={2} className="mb-1">
						<Form.Select
							size="sm"
							className="w-100 bg-dark text-success border-0 fw-bold fs-6"
							onChange={(e) => {
								const [key, order] = e.target.value.split(",");
								setSortKey(key);
								setSortOrder(order);
							}}
							value={`${sortKey},${sortOrder}`}
						>
							<option value="last_name,asc">Last Name Asc</option>
							<option value="last_name,desc">Last Name Desc</option>
							<option value="rating,asc">Value Asc</option>
							<option value="rating,desc">Value Desc</option>
						</Form.Select>
					</Col>
					<Col md={2} className="text-center justify-content-center mb-1">
						<Form.Select
							size="sm"
							className="w-100 bg-dark text-success border-0 fw-bold fs-6"
							onChange={(e) => setFilterGender(e.target.value)}
							value={filterGender}
						>
							<option value="">Gender</option>
							<option value="m">Male</option>
							<option value="f">Female</option>
						</Form.Select>
					</Col>
					<Col md={2}>
						<Form.Select
							size="sm"
							value={filterCountry}
							onChange={(e) => setFilterCountry(e.target.value)}
							className="w-100 bg-dark text-success border-0 fw-bold fs-6"
						>
							<option value="">Country</option>
							{uniqueCountries.map((country) => (
								<option key={country} value={country}>
									{country}
								</option>
							))}
						</Form.Select>
					</Col>
				</Row>
				<Row className="mb-3">
					<Col>
						<Form.Group>
							<Form.Control
								type="search"
								placeholder="Search for a rider..."
								className="bg-dark text-white border-0 custom-placeholder rounded-pill"
								style={{ maxWidth: "20rem" }}
								onChange={handleSearch}
							/>
						</Form.Group>
					</Col>
				</Row>
				{gameModeAssignment === GameModeAssignemts.Budget && (
					<>
						{sortedAndFilteredRiders.map((rider: Rider) => (
							<BudgetModeEligibleRiderCard
								key={rider._id}
								rider={rider}
								sport={sport ?? ""}
								isAddDisabled={isAddDisabled}
								addRiderToTeam={addRiderToTeam}
							/>
						))}
					</>
				)}
				{gameModeAssignment === GameModeAssignemts.PickAndRankHardline && (
					<>
						{sortedAndFilteredRiders.map((rider: Rider) => (
							<BudgetModeEligibleRiderCard
								key={rider._id}
								rider={rider}
								sport={sport ?? ""}
								isAddDisabled={isAddDisabled}
								addRiderToTeam={addRiderToTeam}
							/>
						))}
					</>
				)}
			</Card.Body>
		</Card>
	);
};

export default EligibleRidersSection;
